const flagMap = {
    ko: '/flags/korea.svg',
    en: '/flags/america.svg',
    ja: '/flags/japan.svg',
    zh: '/flags/china.svg',
    'zh-cn': '/flags/china.svg',
    'zh-tw': '/flags/taiwan.svg',
    de: '/flags/germany.svg',
    fr: '/flags/france.svg',
    es: '/flags/spain.svg',
    it: '/flags/italy.svg',
    pt: '/flags/portugal.svg',
    ru: '/flags/russia.svg',
    nl: '/flags/netherlands.svg',
    vi: '/flags/vietnam.svg',
    th: '/flags/thailand.svg',
    id: '/flags/indonesia.svg',
    ms: '/flags/malaysia.svg',
    mn: '/flags/mongol.svg',
    tr: '/flags/turkey.svg',
    pl: '/flags/poland.svg',
    cs: '/flags/cheko.svg',
    ro: '/flags/romania.svg',
    hu: '/flags/hungary.svg',
    el: '/flags/greece.svg',
    sv: '/flags/sweden.svg',
    no: '/flags/norway.svg',
    da: '/flags/denmark.svg',
    fi: '/flags/finland.svg',
    he: '/flags/israel.svg',
    ar: '/flags/saudi_arabia.svg',
    uk: '/flags/ukraine.svg',
    uz: '/flags/uzbekistan.svg',
    hi: '/flags/indo.svg',
    km: '/flags/cambodia.svg',
    kk: '/flags/kazakhstan.svg',
    ky: '/flags/kyrgyzstan.svg',
    lo: '/flags/laos.svg',
};

export default flagMap;
